import { adminHttpClient } from '../commons/adminHttpClient'

export interface InsurancePremiumDetails {
  amount: number
  statusesByMonthDto: [
    {
      monthShort: string
      status: number
    },
  ]
}

export const getInsurancePremiumDetails = (
  planPeriodId?: string,
  recurringExpenseId?: string,
): Promise<InsurancePremiumDetails> => {
  return adminHttpClient.get(`Expenses/PremiumExpenseDetails/${planPeriodId}/${recurringExpenseId}`)
}
